import { Box, Flex, Image, Input, Text } from "@chakra-ui/react";
import styled from "styled-components";

export const ContainerUploadBoleto = styled(Box)`
  width: 100%;
  height: 100vh;
`;
export const FinanceiroContainerText = styled.div`
  font-family: "Arial", sans-serif;
  background-color: #378bbf;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContainerBodyUploadBoleto = styled(Flex)`
  width: 100%;
  height: calc(100vh - 110px);
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const FlexInput = styled(Flex)`
  position: relative;
  z-index: 10;
  margin: 100px auto 0 auto;
  width: 900px;
  justify-content: space-between;
  align-items: center;
  left: -20px;
`;
export const ContainerFlexUploadBoleto = styled(Box)`
  display: flex;
  box-shadow: 16px 14px 20px rgba(0, 0, 0, 0.2);
  width: 800px;
  height: 600px;
  background: gray;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  border: 4px dashed white;
  transition: all ease 0.3s;
  border: none;
  &::before {
    content: "";
    transition: all ease 0.3s;
    position: absolute;
    width: 200px;
    height: 200%;
    background: linear-gradient(white, white);
    animation: animate 4s linear infinite;
  }
  &::after {
    content: "";
    position: absolute;
    inset: 4px;
    background: gray;
    border-radius: 11px;
  }
  border-radius: 15px;
  overflow: hidden;

  @keyframes animate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ButtonEviar = styled(Box)`
  width: 250px;
  height: 35px;
  background-color: #DF8025;
  border-radius: 5px;
  color: white;
  /* width: 150px;
  height: 50px;
  border: 2px solid white;
  font-family: 'Arial',sans-serif;
  font-size: 20px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  transition: 1s;
  color: white;
  opacity: 0;
  &:focus {
    border: 1px solid white;
  }
  animation: has-shown 1s cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.3s forwards;
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }
  &::before,
  &::after {
    position: absolute;
    background: gray;
    z-index: -1;
    transition: 0.5s;
    content: "";
  }

  &::before {
    height: 50px;
    width: 130px;
  }

  &::after {
    width: 150px;
    height: 30px;
  }

  .noselect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  &:hover::before {
    width: 0px;
    background: gray;
    color: white;
  }

  &:hover::after {
    color: white;
    height: 0px;
    background: gray;
  }

  &:hover {
    color: white;
    background: gray;
  }
  &:focus::before {
    width: 0px;
    background: gray;
    color: white;
  }

  &:focus::after {
    color: white;
    height: 0px;
    background: gray;
  }

  &:focus {
    border: 1px solid white;
    color: white;
    background: gray;
  } */
`;
export const InputFile = styled.div`
  height: 35px;
  position: relative;
  width: 250px;
  background-color: #378bbf;
  border-radius: 5px;
  /* opacity: 0; */
  /* animation: has-shown 1s cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.2s forwards;
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  } */

  label,
  input {
    display: block;
    height: 35px;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    border-radius: 5px;
    background-color: #378bbf;
  }

  label {
    background-color: #378bbf;
    display: inline-block;
    font-size: 16px;
    line-height: 35px;
    padding: 0;
    bottom: 10px;
    text-align: center;
    font-family: "Arial", sans-serif;
    white-space: nowrap;
    border-radius: 5px;
    color: white;
  }

  input[type="file"] {
    opacity: 0;
  }
`;
export const ImageIconUpload = styled(Image)`
  width: auto;
  height: 100px;
  z-index: 10;
  position: relative;
  margin: 220px auto 0 auto;
  /* animation: tilt-in-top-1 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both,
    blink-1 1s both;
  @keyframes tilt-in-top-1 {
    0% {
      transform: rotateY(30deg) translateY(-300px) skewY(-30deg);
      opacity: 0;
    }
    100% {
      transform: rotateY(0deg) translateY(0) skewY(0deg);
      opacity: 1;
    }
  }
  @keyframes blink-1 {
    0%,
    50%,
    100% {
      opacity: 1;
    }
    25%,
    75% {
      opacity: 0;
    }
  } */
`;
export const TextTitle = styled(Text)`
  font-family: "Arial", sans-serif;
  z-index: 10;
  color: white;
  font-size: 35px;
  text-align: center;
  border-bottom: 1px solid white;
  margin-top: 10px;
  /* animation: has-shown 1s cubic-bezier(0.785, 0.135, 0.15, 0.86) forwards;
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  } */
`;
export const InputNNota = styled(Input)`
  font-family: "Arial", sans-serif;
  z-index: 10;
  border-color: #378bbf;
  text-align: center;
  /* opacity: 0; */
  /* animation: has-shown 1s cubic-bezier(0.785, 0.135, 0.15, 0.86) 0.1s forwards;
  @keyframes has-shown {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  } */
`;
